// Shared business constants and helpers used across all pages

export const BUSINESS_NAME = "Custom tshirt printing co.";
export const BUSINESS_SLOGAN = "We print your ideas";
export const BUSINESS_EMAIL = "truecolourdtf@gmail.com";
export const BUSINESS_MOBILE = "7982491307";
export const BUSINESS_ADDRESS =
  "304, 1st Floor, Chaudhary Market, Maliwara, Nehru Nagar, Ghaziabad, Uttar Pradesh - 201001";

export const LOGO_URL = "/images/logo.png";
export const BANNER_URL = "/images/dtf-banner.png";
export const PEEL_URL = "/images/dtf-peel.png";
export const SIZE_REFERENCE_URL = "/images/size-reference.png";

// Imagery for the landing selector + service pages
export const IMG_PLAIN_TSHIRT = "/images/tshirt-manufacturing.png";
export const IMG_TSHIRT_RACK =
  "https://images.pexels.com/photos/8396725/pexels-photo-8396725.jpeg?auto=compress&cs=tinysrgb&w=1200";
export const IMG_POD = "/images/pod-delivered.png";
export const IMG_POD_UNBOX =
  "https://images.pexels.com/photos/6958409/pexels-photo-6958409.jpeg?auto=compress&cs=tinysrgb&w=1200";

export const waLink = (text) =>
  `https://wa.me/91${BUSINESS_MOBILE}?text=${encodeURIComponent(text)}`;
